export default __webpack_public_path__ + "static/media/remitaLogo.a2279beb.png";